import utils from '@/common/js/utils'
import baizeCoder from '@/common/js/baize_coder'
import { getWxUrl, getWxOpenId, getWxUserInfo, userDetail, security } from '@/api/wechat/index'
import tools from '@/common/js/tools'

export default {
  scope: '',
  code: '',
  // 获取openId
  async getOpenId () {
    this.scope = 'snsapi_base'
    this.code = utils.getUrlPara('code')

    let openId = sessionStorage.getItem('openId')

    if (openId) {
      return true
    }

    if (this.code) {
      this.getUserOpenId()
    } else {
      this.getRedirectUrl()
    }
  },
  // 获取用户信息
  async getUserInfo (type) {
    this.scope = 'snsapi_userinfo'
    this.code = utils.getUrlPara('code')

    // 手机登录或微信登录
    sessionStorage.setItem('loginType', type)

    let userInfo = sessionStorage.getItem('userInfo')

    if (userInfo) {
      return userInfo
    }
    if (this.code) {
      await this.getUserWxData()
    } else {
      await this.getRedirectUrl()
    }
  },
  // 获取跳转路径
  async getRedirectUrl () {
    let res = await getWxUrl()
    console.log(res)
    let redirectUrl = window.encodeURIComponent(window.location.href)
    sessionStorage.setItem('appid', res.data.pensionWxAppid)
    sessionStorage.setItem('redirectUrl', window.location.pathname + window.location.search)

    let url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${res.data.pensionWxAppid}&redirect_uri=${redirectUrl}&response_type=code&scope=${this.scope}&state=STATE#wechat_redirect
`     
    // console.log(url, 'url')
    window.location.replace(url)
  },
  // 获取openId
  async getUserOpenId () {
    let formData = {
      code: this.code
    }

    let res = await getWxOpenId(formData)
    sessionStorage.setItem('openId', res.data.openId)
    tools.$router.replace(sessionStorage.getItem('redirectUrl'))
    // window.location.replace(window.location.origin + sessionStorage.getItem('redirectUrl'))
  },
  // 获取用户信息
  async getUserWxData () {

    let publicKey = await security();
    sessionStorage.setItem('publicKey', publicKey.data)

    let formStr = baizeCoder({
      wxAppId: sessionStorage.getItem('appid'),
      wxCode: this.code
    });

    let res = await getWxUserInfo(formStr);

    sessionStorage.setItem('openId', res.data.openid)
    // 用后清除
    sessionStorage.removeItem('appid')

    if (!res.data.flag && sessionStorage.getItem('loginType') == 'phone') {
      sessionStorage.removeItem('loginType')
      tools.$router.replace('/login')
      return
    }
    if (res.data.flag) {
      await this.getUserInfoData(res.data.key)
    } else {
      res.data.token = sessionStorage.getItem('token')
      sessionStorage.setItem('userInfo', JSON.stringify(res.data))
      tools.$router.replace(sessionStorage.getItem('redirectUrl'))
      // window.location.replace(window.location.origin + sessionStorage.getItem('redirectUrl'))
    }
  },
  // 获取用户信息
  async getUserInfoData (userKey) {
    let res = await userDetail({
      primaryKey: userKey
    })
    // console.log(res)
    res.data.flag = true;
    res.data.token = sessionStorage.getItem('token')
    sessionStorage.setItem('userInfo', JSON.stringify(res.data))
    tools.$router.replace(sessionStorage.getItem('redirectUrl'))
    // window.location.replace(window.location.origin + sessionStorage.getItem('redirectUrl'))
  },
  // 获取用户信息
  async getUserInfoApp (userKey) {
    let res = await userDetail({
      primaryKey: userKey
    })
    
    res.data.flag = true
    res.data.token = sessionStorage.getItem('token')
    this.$store.commit('setUserInfo', res.data)
  }
}
